import { useRef } from 'react'

import styled from 'styled-components'

import { device } from '@/common/constants/device'
import CreativeIdeas from 'components/Landing/CreativeIdeas'
import Exclusives from 'components/Landing/Exclusives'
import Possibilities from 'components/Landing/Possibilities'
import Selection from 'components/Landing/Selection'
import Offer from 'components/Landing/Offer'
import Pickup from 'components/Landing/Pickup'
import Socials from 'components/Landing/Socials'
import useIsModalVisible from '@/hooks/useIsModalVisible'
import PremiumEnterpriseTarrifModal from '@/components/Premium/PremiumEnterpriseTarrifModal'
import { PREMIUM_PAYMENT_TARRIF_MODAL } from '@/common/constants/modals'
import Tools from '@/components/Landing/Tools'
import Landing6 from '@/components/landings/Landing6'

const Wrap = styled.div`
  margin-left: auto;
  margin-right: auto;

  @media ${device.mobileL} {
    max-width: 425px;
  }

  @media ${device.tablet} {
    max-width: 768px;
  }

  @media ${device.laptop} {
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
  }

  .summer-banner {
    position: relative;
    z-index: 1;
    margin-bottom: 24px;

    img {
      border-radius: 24px;
    }
  }
`

const LandingDefault = ({ experimentKey }) => {
  const ratesRef = useRef()
  const isVisiblePaymentTarrifModal = useIsModalVisible(
    PREMIUM_PAYMENT_TARRIF_MODAL
  )

  return (
    <Wrap>
      <Landing6 experimentKey={experimentKey} />
      <CreativeIdeas ratesRef={ratesRef} />
      <Exclusives />
      <Possibilities />
      <Tools />
      <Selection />
      <Offer />
      <Pickup />
      {isVisiblePaymentTarrifModal && <PremiumEnterpriseTarrifModal />}
      {/* <Reviews /> */}
      <Socials />
    </Wrap>
  )
}

export default LandingDefault
